var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileCheck = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 16.5C5.725 16.5 5.5 16.275 5.5 16V4C5.5 3.725 5.725 3.5 6 3.5H11V6C11 6.55312 11.4469 7 12 7H14.5V16C14.5 16.275 14.275 16.5 14 16.5H6ZM6 2C4.89688 2 4 2.89688 4 4V16C4 17.1031 4.89688 18 6 18H14C15.1031 18 16 17.1031 16 16V6.82812C16 6.29688 15.7906 5.7875 15.4156 5.4125L12.5844 2.58438C12.2094 2.20938 11.7031 2 11.1719 2H6ZM13.0312 10.3625C13.325 10.0688 13.325 9.59375 13.0312 9.30312C12.7375 9.0125 12.2625 9.00938 11.9719 9.30312L9.16875 12.1062L8.03125 10.9688C7.7375 10.675 7.2625 10.675 6.97187 10.9688C6.68125 11.2625 6.67812 11.7375 6.97187 12.0281L8.6375 13.6938C8.77812 13.8344 8.96875 13.9125 9.16875 13.9125C9.36875 13.9125 9.55937 13.8344 9.7 13.6938L13.0312 10.3625Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "72dc5e36290a28c12086014c88b6a00e.svg";